
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21.5 3.9C20.3 2.7 18.7 2 17 2c-1.7 0-3.4.7-4.6 1.9l-.4.4-.4-.4A6.42 6.42 0 0 0 7 2c-1.7 0-3.3.7-4.5 1.9s-2 2.9-2 4.6.7 3.4 1.9 4.6l8.8 8.8c.2.2.4.3.7.3s.5-.1.7-.3l8.8-8.8c2.7-2.5 2.7-6.7.1-9.2zm-1.4 7.8L12 19.8l-8.1-8.1c-1.8-1.8-1.8-4.6 0-6.4C4.7 4.4 5.9 4 7 4c1.2 0 2.3.4 3.2 1.3l1.1 1.1c.4.4 1 .4 1.4 0l1-1.1c.9-.8 2-1.3 3.3-1.3 1.2 0 2.3.5 3.2 1.3.8.9 1.3 2 1.3 3.2s-.5 2.3-1.4 3.2z"}})])
      }
    
      }
    